import { Fragment, useEffect, useState } from "react";
import { Col, Row, Table } from "reactstrap";
import { CollapseableCard } from "../../../CommonElements";
import { AlignJustify, Archive, UserCheck, Users } from "react-feather";
import { H6 } from "../../../AbstractElements";
import { Link } from "react-router-dom";
// import getUnitKerja from "../services/getUnitKerja";
import useAxios from "../../../Utils/useAxios";
import { getAtasan, getName, getUser } from "../../../Utils/externalFunctions";

const Asessment = (props) => {
  const axiosInstance = useAxios();
  const userRole = localStorage.getItem("role");
  const nama = getName() ?? getUser();
  const unitKerjaId = localStorage.getItem("unit_kerja_id");
  const unitKerja = localStorage.getItem("unit_kerja");
  const atasan = getAtasan();
  const [currentUnitKerja, setCurrentUnitKerja] = useState([]);

  let isMounted = true;
  useEffect(() => {
    unitKerjaStaf();

    return () => {
      isMounted = false;
    };
  }, []);

  const unitKerjaStaf = async () => {
    // getUnitKerja(axiosInstance, unitKerjaId).then((res) => {
    //   setCurrentUnitKerja(res.data);
    // });
  };

  const quickOptionData = [
    {
      id: 1,
      title: "Isi Form Individu",
      path: `${process.env.PUBLIC_URL}/assessment/formindividu`,
      icon: <UserCheck />,
      role: ["Staf", "Atasan"],
    },
    {
      id: 2,
      title: "Isi Form Kelompok",
      path: `${process.env.PUBLIC_URL}/assessment/formkelompok`,
      icon: <Users />,
      role: ["Atasan"],
    },
    {
      id: 3,
      title: "Lihat Rekap Individu",
      path: `${process.env.PUBLIC_URL}/assessment/rekapindividu`,
      icon: <AlignJustify />,
      role: ["Atasan", "Admin"],
    },
    {
      id: 4,
      title: "Lihat Rekap Kelompok",
      path: `${process.env.PUBLIC_URL}/assessment/rekapkelompok`,
      icon: <Archive />,
      role: ["Atasan", "Admin"],
    },
  ];

  return (
    <Fragment>
      <Col {...props}>
        <CollapseableCard title={"Asesmen"}>
          <Table className="w-75">
            <tbody>
              <tr>
                <th>Nama</th>
                <td>: {nama}</td>
              </tr>
              <tr>
                <th>Unit Kerja</th>
                <td>: {unitKerja}</td>
              </tr>
              <tr>
                <th>Atasan</th>
                <td>: {atasan}</td>
              </tr>
              <tr>
                <th>Periode Penilaian</th>
                <td>: Januari - Agustus 2025</td>
              </tr>
            </tbody>
          </Table>
          <Row className="options-main text-center">
            {quickOptionData
              .filter((item) => item.role.includes(userRole)) // Filter tombol berdasarkan role pengguna
              .map((item) => {
                const button = (
                  <div className="option-box btn-outline-primary rounded-2 h-100 d-flex flex-column justify-content-center align-items-center">
                    {item.icon}
                    <H6>{item.title}</H6>
                  </div>
                );
                return (
                  <Col xs="6" className="my-4" key={item.id}>
                    <Link to={item.path}>{button}</Link>
                  </Col>
                );
              })}
          </Row>
        </CollapseableCard>
      </Col>
    </Fragment>
  );
};

export default Asessment;
